import { createStore } from 'zustand/vanilla';

// Ephemeral immediate display. The next voice user message also carries a
// display-only interruption marker so the transcript survives a reload.
export const interruptionStore = createStore<{ messages: readonly string[] }>(() => ({
  messages: [],
}));
export function markInterrupted(messageId: string) {
  const messages = interruptionStore.getState().messages;
  if (!messages.includes(messageId))
    interruptionStore.setState({ messages: [...messages.slice(-127), messageId] });
}
export function clearInterruptions() {
  interruptionStore.setState({ messages: [] });
}

export function isInterruptionMarker(
  part: { type: string; name?: string; data?: unknown },
  messageId: string,
) {
  if (part.type !== 'data' || part.name !== 'speech' || !part.data || typeof part.data !== 'object')
    return false;
  const data = part.data as { via?: string; interrupted?: { messageId?: string } };
  return data.via === 'voice' && data.interrupted?.messageId === messageId;
}
